import { render, staticRenderFns } from "./ModalEnvironmentalPromise.vue?vue&type=template&id=0b1b4112&scoped=true&"
import script from "./ModalEnvironmentalPromise.vue?vue&type=script&lang=js&"
export * from "./ModalEnvironmentalPromise.vue?vue&type=script&lang=js&"
import style0 from "./ModalEnvironmentalPromise.vue?vue&type=style&index=0&id=0b1b4112&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1b4112",
  null
  
)

export default component.exports